import Phaser from 'phaser';
import { generateFloorTile, generateHighlightTile } from '@/assets/FloorTileGenerator';
import { generateEquipmentTextures } from '@/assets/EquipmentGenerator';
import { generateRaverTextures } from '@/assets/RaverGenerator';
import { generateEffectTextures } from '@/assets/EffectTextureGenerator';
import { generateSpecialCharacterTextures } from '@/assets/SpecialCharacterGenerator';

/**
 * BootScene: generates all procedural textures, then starts MainScene + UIScene.
 */
export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'BootScene' });
  }

  create(): void {
    // Generate all procedural textures
    generateFloorTile(this);
    generateHighlightTile(this, 'highlight-valid', '#00ff00');
    generateHighlightTile(this, 'highlight-invalid', '#ff0000');
    generateHighlightTile(this, 'highlight-hover', '#ffffff');
    generateHighlightTile(this, 'highlight-aoe', '#00ffff');
    generateEquipmentTextures(this);
    generateRaverTextures(this);
    generateEffectTextures(this);
    generateSpecialCharacterTextures(this);

    // Launch both game scenes simultaneously
    this.scene.start('MainScene');
    this.scene.launch('UIScene');
  }
}
